import { render, staticRenderFns } from "./change_the_person.vue?vue&type=template&id=0fe36948&scoped=true&"
import script from "./change_the_person.vue?vue&type=script&lang=js&"
export * from "./change_the_person.vue?vue&type=script&lang=js&"
import style0 from "./change_the_person.vue?vue&type=style&index=0&id=0fe36948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe36948",
  null
  
)

export default component.exports